/**
 * Recherche UNIQUEMENT sur ENTER - Anti-Klaviyo
 */
(function() {
  'use strict';
  
  if (!window.location.pathname.includes('/search')) return;
  
  // Attendre que tout soit chargé
  setTimeout(function() {
    const searchInput = document.querySelector('.search-results-input');
    const productGrid = document.querySelector('#product-grid ul.grid.product-grid');
    const productCount = document.querySelector('#ProductCountDesktop');
    const searchResultsCount = document.querySelector('#SearchResultsCount');
    const loadingOverlay = document.querySelector('#product-grid .loading-overlay');
    
    if (!searchInput || !productGrid) {
      console.warn('Éléments de recherche non trouvés');
      return;
    }
    
    let isSearching = false;
    let enterPressed = false;
    
    const isFrench = window.location.pathname.includes('/fr') || 
                     window.location.pathname.includes('/fr-ca') ||
                     document.documentElement.lang.toLowerCase().includes('fr');
    
    const urlParams = new URLSearchParams(window.location.search);
    const searchTerm = urlParams.get('q');
    
    if (searchTerm) {
      searchInput.value = searchTerm.replace(/"/g, '').replace(/\*/g, '');
    }

    searchInput.focus();
    const length = searchInput.value.length;
    searchInput.setSelectionRange(length, length);
    
    function formatSearchQuery(query) {
      const cleaned = query.trim().replace(/\s+/g, ' ');
      return cleaned + '*';
    }
    
    function loadSearchResults(query) {
      if (query.length < 2) return;
      if (isSearching) return;
      
      // ✅ VÉRIFIER que Enter a été pressé
      if (!enterPressed) {
        console.log('❌ Recherche bloquée - Enter non pressé');
        return;
      }
      
      enterPressed = false; // Reset
      isSearching = true;
      
      const formattedQuery = formatSearchQuery(query);
      
      console.log('✅ RECHERCHE AUTORISÉE:', query);
      
      if (loadingOverlay) {
        loadingOverlay.style.display = 'block';
        loadingOverlay.style.opacity = '1';
      }
      productGrid.classList.add('is-loading');
      productGrid.style.opacity = '0.5';
      searchInput.classList.add('is-searching');
      
      const newUrl = window.Shopify.routes.root + 'search?q=' + encodeURIComponent(formattedQuery) + '&type=product&options[prefix]=last&limit=250';
      window.history.replaceState({ query: formattedQuery }, '', newUrl);
      
      fetch(newUrl + '&section_id=main-search')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          const newGrid = doc.querySelector('#product-grid ul.grid.product-grid');
          const newCount = doc.querySelector('#ProductCountDesktop');
          
          if (newGrid && newGrid.innerHTML.trim() !== '') {
            productGrid.innerHTML = newGrid.innerHTML;
            
            if (productCount && newCount) {
              productCount.innerHTML = newCount.innerHTML;
            }
            
            if (searchResultsCount) {
              const resultCount = newGrid.querySelectorAll('.grid__item').length;
              const displayQuery = query;
              const countText = isFrench 
                ? resultCount + ' résultat' + (resultCount > 1 ? 's' : '') + ' pour "' + displayQuery + '"'
                : resultCount + ' result' + (resultCount > 1 ? 's' : '') + ' for "' + displayQuery + '"';
              searchResultsCount.textContent = countText;
            }
          } else {
            const displayQuery = query;
            const noResultsTitle = isFrench 
              ? 'Aucun résultat pour "' + displayQuery + '"'
              : 'No results for "' + displayQuery + '"';
            
            const noResultsText = isFrench
              ? 'Essayez avec moins de termes ou des mots-clés différents.'
              : 'Try using fewer terms or different keywords.';
            
            const countText = isFrench
              ? '0 résultat pour "' + displayQuery + '"'
              : '0 results for "' + displayQuery + '"';
            
            productGrid.innerHTML = '<li class="grid__item search-no-results" style="grid-column: 1 / -1;"><div style="text-align: center; padding: 6rem 2rem;"><h2 class="h2" style="margin-bottom: 1.5rem;">' + noResultsTitle + '</h2><p class="search-suggestion">' + noResultsText + '</p></div></li>';
            
            if (productCount) {
              productCount.innerHTML = '<span>' + countText + '</span>';
            }
            
            if (searchResultsCount) {
              searchResultsCount.textContent = countText;
            }
          }
          
          if (loadingOverlay) {
            loadingOverlay.style.opacity = '0';
            setTimeout(function() {
              loadingOverlay.style.display = 'none';
            }, 100);
          }
          productGrid.classList.remove('is-loading');
          productGrid.style.opacity = '1';
          searchInput.classList.remove('is-searching');
          isSearching = false;
        })
        .catch(function(error) {
          console.error('Erreur de recherche:', error);
          
          if (loadingOverlay) {
            loadingOverlay.style.opacity = '0';
            loadingOverlay.style.display = 'none';
          }
          productGrid.classList.remove('is-loading');
          productGrid.style.opacity = '1';
          searchInput.classList.remove('is-searching');
          isSearching = false;
        });
    }
    
    // ✅ BLOQUER toutes les recherches sauf si Enter est pressé
    const originalFetch = window.fetch;
    window.fetch = function() {
      const url = arguments[0];
      if (typeof url === 'string' && url.includes('/search') && url.includes('section_id=main-search')) {
        if (!enterPressed && !isSearching) {
          console.log('🚫 FETCH bloqué:', url);
          return Promise.resolve(new Response('', { status: 200 }));
        }
      }
      return originalFetch.apply(this, arguments);
    };
    
    // ✅ Détecter Enter
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        console.log('✅ ENTER PRESSÉ');
        e.preventDefault();
        e.stopImmediatePropagation();
        enterPressed = true;
        const query = searchInput.value.trim();
        if (query.length >= 2) {
          loadSearchResults(query);
        }
      }
    }, true); // ✅ useCapture = true pour capturer avant Klaviyo
    
    // ✅ Form submit
    const searchForm = searchInput.closest('form');
    if (searchForm) {
      searchForm.addEventListener('submit', function(e) {
        console.log('📝 FORM SUBMIT');
        e.preventDefault();
        e.stopImmediatePropagation();
        enterPressed = true;
        const query = searchInput.value.trim();
        if (query.length >= 2) {
          loadSearchResults(query);
        }
      }, true);
    }
    
  }, 500); // Attendre que Klaviyo se charge
  
})();